var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 160,
    viewBox: "0 0 133 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.866 29.3203H74.4531V55.5857H101.866V29.3203Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4604 41.4644C94.4604 38.1495 91.7732 35.4622 88.4583 35.4622C85.1434 35.4622 82.4561 38.1495 82.4561 41.4644C82.4561 44.7793 85.1434 47.4665 88.4583 47.4665C91.7732 47.4665 94.4604 44.7793 94.4604 41.4644Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5498 29.3202V23.859L85.5098 20.1087L89.104 17.1952L86.8453 14.4088V12.6904",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6685 29.3202V24.6824L83.6196 19.6876L87.2138 16.7741L85.9639 15.2321V12.7539",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7695 11.329C87.7695 10.5199 87.1135 9.86401 86.3044 9.86401C85.4953 9.86401 84.8394 10.5199 84.8394 11.329C84.8394 12.1381 85.4953 12.7941 86.3044 12.7941C87.1135 12.7941 87.7695 12.1382 87.7695 11.329Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4172 55.5857L82.2612 60.9749",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7319 55.5857V61.2047",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6221 61.2046H84.2804",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5823 61.2046H98.2406L104.074 104.435L69.9316 104.058L72.4961 84.7454",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7773 75.0985L74.0365 73.1462",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0366 73.1462L74.6519 68.5122",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.105 65.0989L75.6221 61.2046",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6764 63.8494C90.6764 61.7813 88.9998 60.1047 86.9317 60.1047C84.8636 60.1047 83.187 61.7813 83.187 63.8494C83.187 65.9176 84.8636 67.5941 86.9317 67.5941C88.9998 67.5941 90.6764 65.9175 90.6764 63.8494Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1975 64.1294C82.6969 64.998 82.1935 65.8646 81.6204 66.6835C81.1473 67.3594 80.6266 68.0028 80.0946 68.6361C79.2203 69.6771 78.3153 70.6912 77.3629 71.6569C76.2678 72.7674 75.11 73.8141 73.9836 74.8992C72.0443 76.7675 70.1982 78.75 68.1058 80.4186C65.9885 82.1069 63.619 83.4738 61.2495 84.8407",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4626 67.2666C88.0115 68.05 87.495 68.9433 86.8443 69.9023C86.1898 70.8671 85.4752 71.7562 84.8484 72.5044C84.2217 73.2527 83.581 73.9884 82.9032 74.7241C81.7499 75.976 80.4849 77.1856 79.3867 78.2199C78.2886 79.2542 77.3448 80.1847 76.2406 81.2769C75.1365 82.3691 73.9336 83.5438 72.5475 84.7026C70.8509 86.1209 69.003 87.3545 67.2795 88.4045C66.2593 89.0261 65.2642 89.5995 64.3115 90.149",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0964 104.215C84.3328 106.267 84.5692 108.319 84.7166 110.375C84.9135 113.123 84.9518 115.879 84.9504 118.643C84.9493 121.035 84.9184 123.433 84.5867 125.789C84.3506 127.465 83.9622 129.12 83.5591 130.773",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3773 104.284C90.6551 106.728 90.9274 109.334 91.0515 111.926C91.1619 114.229 91.1841 116.48 91.1827 118.688C91.1812 121.046 91.162 123.631 90.7935 126.399C90.6098 127.778 90.3498 129.087 90.0723 130.317",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9995 136.723C77.4333 135.584 77.8671 134.445 78.6494 133.623C79.3872 132.848 80.4349 132.355 81.4296 131.824C82.143 131.443 82.8291 131.043 83.5591 130.773C84.7819 130.319 86.1281 130.228 87.4968 130.211C89.3803 130.188 91.3061 130.305 92.9014 131.078C93.8628 131.544 94.7041 132.247 95.4608 133.159C96.2372 134.095 96.9245 135.25 96.695 136.311C96.5543 136.962 96.0697 137.577 95.5127 138.015C93.7 139.441 91.1222 138.988 88.835 138.999C85.9577 139.014 83.5402 139.764 80.3514 139.359C79.0049 139.188 77.5208 138.812 77.1425 137.759C77.032 137.452 77.0157 137.088 76.9995 136.723Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.576 104.176C80.989 107.335 81.402 110.494 81.4687 113.662C81.4981 115.061 81.4599 116.462 81.4687 117.872C81.4751 118.912 81.5071 119.956 81.3648 120.976C81.2262 121.969 80.9225 122.938 80.6762 123.92C80.335 125.281 80.1041 126.667 79.6239 127.974C79.4541 128.436 79.2532 128.888 79.0522 129.339",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2515 127.729C83.3304 127.927 82.4093 128.124 81.5205 128.403C80.6862 128.664 79.8804 128.996 79.052 129.339C78.0812 129.741 77.0794 130.159 76.3108 130.774C75.4454 131.468 74.8758 132.413 74.1541 133.51C73.735 134.148 73.2645 134.837 73.5046 135.427C73.5774 135.606 73.7155 135.775 73.8683 135.921C74.3189 136.35 74.8974 136.569 75.4793 136.745C75.9922 136.9 76.508 137.021 77.0237 137.143",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4529 35.3684C72.135 36.7467 71.3733 39.7431 72.7517 42.061C73.168 42.7611 73.7528 43.3459 74.4529 43.7622",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3117 90.1492C63.7768 90.3893 63.3687 90.8602 62.9049 91.2751C61.6842 92.3671 60.0782 93.0713 58.4072 93.2621C56.6437 93.4635 54.8078 93.0932 53.3387 92.1502C53.0871 91.9887 52.8463 91.8104 52.0991 90.9225",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2494 84.8406C60.6055 85.2216 59.9616 85.6026 59.2804 85.9384C57.7837 86.6761 56.1066 87.1957 54.9205 88.288C54.2094 88.9428 53.6747 89.8036 53.1401 90.6643",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6553 69.4734V86.4828C22.6553 86.4903 22.6605 86.4969 22.6678 86.4986L46.8682 92.2194L53.1403 90.6645",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 81.6474V69.8586",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 61.6061L42.7033 59.7485L66.6488 62.052",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 61.606L46.8678 64.5951L66.6488 62.0518",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8682 92.2192V76.9126",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2198 61.606L17.0611 50.5486C17.06 50.5465 17.0593 50.5442 17.0591 50.5419C17.0584 50.533 17.0651 50.5252 17.074 50.5245L36.0156 49.0342C36.0216 49.0338 36.0274 49.0367 36.0306 49.0418L42.7034 59.7484",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7036 59.7484L49.7671 50.235C49.7704 50.2306 49.7758 50.2281 49.7814 50.2286L72.6825 52.0174C72.8651 52.0465 73.0505 52.0548 73.235 52.042L66.6491 62.0518",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2199 61.606L12.4522 67.6033C12.4444 67.6076 12.4415 67.6175 12.4459 67.6253C12.4483 67.6297 12.4526 67.6327 12.4575 67.6335L35.8702 71.3527C35.874 71.3534 35.878 71.3526 35.8812 71.3505L46.868 64.5951",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8682 64.5953L57.911 70.9777C57.9143 70.9796 57.9181 70.9803 57.9218 70.9797L78.7821 67.5555C78.7909 67.554 78.7969 67.5457 78.7955 67.5368C78.7946 67.5315 78.7911 67.5269 78.7861 67.5247L66.6492 62.052",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7507 47.611C42.7507 46.8325 42.1196 46.2014 41.3412 46.2014C40.5627 46.2014 39.9316 46.8325 39.9316 47.611C39.9316 48.3894 40.5627 49.0205 41.3412 49.0205C42.1196 49.0205 42.7507 48.3894 42.7507 47.611Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2036 47.6111C43.2036 46.5824 42.3697 45.7485 41.3411 45.7485C40.3124 45.7485 39.4785 46.5824 39.4785 47.6111C39.4785 48.6397 40.3124 49.4736 41.3411 49.4736C42.3697 49.4736 43.2036 48.6397 43.2036 47.6111Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5322 49.043L42.7493 49.2259",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9622 50.7908L42.5641 49.4139C42.564 49.4138 42.5639 49.4137 42.5638 49.4136C42.5599 49.4094 42.5602 49.403 42.5643 49.3991L43.1205 48.8826C43.1205 48.8825 43.1207 48.8824 43.1208 48.8823C43.1251 48.8787 43.1316 48.8792 43.1352 48.8835L44.4051 50.3795C44.4357 50.4611 44.4323 50.5516 44.3958 50.6308C44.3203 50.7947 44.1261 50.8664 43.9622 50.7908Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5474 46.8828C40.6588 46.7971 40.7703 46.7114 40.8951 46.6511C41.0624 46.5704 41.2537 46.5356 41.4416 46.5271C41.5332 46.5229 41.624 46.525 41.7149 46.5271",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6885 48.5128C40.802 48.5726 40.9155 48.6324 41.0362 48.6535C41.178 48.6782 41.3298 48.6493 41.475 48.6121C41.6408 48.5697 41.7981 48.5164 41.9554 48.4631",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7505 48.8286L42.9294 49.049",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8862 70.0317C79.9978 70.3599 81.1093 70.6881 81.889 71.3908C82.6269 72.0559 83.0676 73.0564 83.5083 74.057",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3633 74.5522C75.2847 74.9916 76.2061 75.4309 76.8213 76.125C77.5705 76.9702 77.8657 78.1932 78.1609 79.4162",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3359 79.4021C70.3282 79.8509 71.3205 80.2998 71.957 81.0445C72.6479 81.8529 72.9195 83.0099 73.1912 84.167",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2822 83.0542C64.9892 83.7662 65.6961 84.4783 66.3 85.2686C66.9416 86.1081 67.4671 87.0361 67.9925 87.964",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4209 107.112C85.4804 106.87 86.5399 106.629 87.5982 106.636C88.6275 106.643 89.6556 106.885 90.6838 107.127",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8525 112.814C85.767 112.43 86.6814 112.046 87.6039 111.996C88.7581 111.934 89.9249 112.393 91.0916 112.853",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9502 118.398C85.8612 118.088 86.7722 117.778 87.6855 117.745C88.8488 117.704 90.0157 118.112 91.1827 118.52",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M84.729 124.601C85.8098 124.447 86.8907 124.293 87.9723 124.29C88.979 124.288 89.9864 124.417 90.9939 124.546",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0376 107.865C81.5851 107.501 82.1327 107.137 82.7199 107.062C83.2723 106.992 83.8597 107.179 84.4471 107.365",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4351 112.634C81.9804 112.205 82.5257 111.777 83.1393 111.658C83.6616 111.557 84.2333 111.68 84.805 111.803",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4673 117.395C82.2428 117.111 83.0182 116.827 83.7386 116.98C84.1542 117.069 84.5514 117.303 84.9485 117.537",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1548 122.067C81.7392 122.053 82.3235 122.039 82.888 122.135C83.5664 122.249 84.216 122.522 84.8656 122.794",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.6fb9d2c6222227e8fe57e470f0886383.svg";
export { ForwardRef as ReactComponent };